import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';
import { baseTableFilter, buildQueryString } from 'utils/general';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	jobCategories: [],
};

export const getAllJobCategory = createAsyncThunk('user/getAllJobCategory', async (filter, { rejectWithValue }) => {
	try {
		const queryData = buildQueryString({
			search: filter.search,
			startDate: filter.startDate,
			endDate: filter.endDate,
			isActive: filter.isActive?.toString(),
		});

		const response = await axiosInstance.get(
			`/job-category/admin?sortBy=${filter?.sortBy ?? baseTableFilter.sortBy}&page=${filter?.page ?? baseTableFilter.page ?? 1}&limit=${filter?.limit ?? baseTableFilter.limit}${queryData ? '&' + queryData : ''}`,
		);

		console.log(response, 'response>27');

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err?.response || 'Error');
	}
});

export const getJobCategoryById = createAsyncThunk('user/getJobCategoryById', async (id, { rejectWithValue }) => {
	try {
		const response = await axiosInstance.get(`/job-category/${id}`);
		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error');
	}
});

export const deleteJobCategory = createAsyncThunk('user/deleteJobCategory', async (id, { rejectWithValue }) => {
	try {
		const response = await axiosInstance.delete(`/job-category/${id}`);

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err?.response || 'Error');
	}
});

export const editJobCategory = createAsyncThunk('user/editJobCategory', async ({ data, catId }, { rejectWithValue }) => {
	try {
		console.log(data, 'PAYLOAD...');

		const response = await axiosInstance.patch(`/job-category/${catId}`, data);
		console.log(response, 'response..');

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err?.response || 'Error');
	}
});

export const addJobCategory = createAsyncThunk('user/addJobCategory', async (data, { rejectWithValue }) => {
	try {
		const response = await axiosInstance.post(`/job-category`, data);
		console.log(response, 'response..');

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err || 'Error');
	}
});

export const jobCategorySlice = createSlice({
	name: 'jobCategory',
	initialState: initialState,
	reducers: {
		showLoading: (state) => {
			state.loading = true;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllJobCategory.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllJobCategory.fulfilled, (state, action) => {
				state.loading = false;
				state.jobCategories = action.payload.result.data || [];
			})
			.addCase(getAllJobCategory.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
				state.jobCategories = [];
			})
			.addCase(getJobCategoryById.pending, (state) => {
				state.loading = true;
			})
			.addCase(getJobCategoryById.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getJobCategoryById.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			})
			.addCase(deleteJobCategory.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteJobCategory.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(deleteJobCategory.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			})
			.addCase(editJobCategory.pending, (state) => {
				state.loading = true;
			})
			.addCase(editJobCategory.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(editJobCategory.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			})
			.addCase(addJobCategory.pending, (state) => {
				state.loading = true;
			})
			.addCase(addJobCategory.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(addJobCategory.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			});
	},
});

export const { showLoading } = jobCategorySlice.actions;

export default jobCategorySlice.reducer;
